import { render, staticRenderFns } from "./InicioImportacaoImagensEmLote.vue?vue&type=template&id=a525bdd8&"
import script from "./InicioImportacaoImagensEmLote.vue?vue&type=script&lang=js&"
export * from "./InicioImportacaoImagensEmLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports